import { getMinContentWidth } from 'features/layout/getMinContentWidth';
import { GridPanelName } from 'features/layout/features/content/types';
import { SourceDetails, SourceKind } from 'features/layout/types';
import { layoutConfig } from 'utils/layout';

const CONTENT_KINDS: SourceKind[] = ['screenshare-local', 'screenshare-remote', 'external'];

export const resolveMinContentWidth = ({
  verticalLayout,
  maximizedStream,
  gridPanel,
  roomWidth,
  roomHeight,
  tileCount,
  contentRatio,
  deviceType,
}: {
  verticalLayout: boolean;
  maximizedStream: SourceDetails | null;
  gridPanel: GridPanelName | null;
  roomWidth: number;
  roomHeight: number;
  tileCount: number;
  contentRatio: number;
  deviceType: string;
}) => {
  if (verticalLayout || !maximizedStream) {
    return layoutConfig.minContentWidth;
  }

  if (!CONTENT_KINDS.includes(maximizedStream.kind) && !gridPanel) {
    return layoutConfig.minContentWidth;
  }

  return getMinContentWidth({ roomWidth, roomHeight, tileCount, contentRatio, deviceType });
};
